module.exports = __webpack_public_path__ + "static/media/svg7.6865278e.svg";